import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import privacyPolicy from '@/assets/documents/privacy-policy.md';
export var PrivacyPolicy = function () {
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(''), content = _b[0], setContent = _b[1];
    useEffect(function () {
        fetch(privacyPolicy)
            .then(function (response) { return response.text(); })
            .then(function (text) {
            setContent(text);
            setIsLoading(false);
        });
    }, []);
    return (_jsx(Root, { children: isLoading ? (_jsx("div", { children: _jsx(CircularProgress, {}) })) : (_jsx(ReactMarkdown, { children: content })) }));
};
var Root = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: '100%',
            display: 'grid',
            gap: '1rem',
            textAlign: 'justify',
            maxHeight: '500px',
            padding: '1rem',
            h3: {
                textAlign: 'center',
            },
            a: {
                color: theme.palette.primary.main,
            },
            ul: {
                listStyle: 'outside',
                marginLeft: '1em',
            },
            fontSize: 'clamp(.6rem, 2.5vw, 1rem)'
        },
        _b[theme.breakpoints.up('md')] = {
            ul: {
                marginLeft: '2rem',
            },
            p: {
                marginLeft: '1rem',
            },
            h5: {
                marginLeft: '1rem',
            },
            h6: {
                marginLeft: '1.5rem',
            },
        },
        _b);
});
